class CartMiniService {
    /*@ngInject*/
    constructor() {
        this.itemsQuantity = 0;
    }

    getItemsQuantity() {
        return this.itemsQuantity;
    }

    setItemsQuantity(itemsQuantity) {
        this.itemsQuantity = itemsQuantity;
    }
}

export default CartMiniService;
